export default {"src":"/_next/static/media/box.95cb4d4b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};